import { useCallback, useState } from "react"

interface DialogHandlerHook {
  visible: boolean
  open: () => void
  close: () => void
}
export function useDialogHandler(): DialogHandlerHook {
  const [visible, setVisible] = useState<boolean>(false)

  const close = useCallback(() => {
    setVisible(false)
  }, [])

  const open = useCallback(() => {
    setVisible(true)
  }, [])

  return { visible, open, close }
}